import Child from '@/models/enrollment/child';
import actionsGetters from './actions.getters';
import actionsCommands from './actions.commands';
import getters from './getters';
import mutations from './mutations';

export const child = {
    namespaced: true,
    state: { 
      invitationLink: String, 
      numberInQueue: null,
      completedForms: 0,
      languages: [], 
      childInfo: null,
      children: new Array<Child>(),
      vaccines: [],
      initialHealthInfo: null,
      allergens: [],
      skinProducts: []
    }, 
    getters,
    actions: {...actionsGetters, ...actionsCommands},
    mutations
};